import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import type { LacTenantOverviewDateRange } from '../../../types/lac';
import { lacQueryKeys } from '../lacQueryKeys';

export type UseLacChatbotAnalyticsQueryOptions = {
  groupByKnowledgeBase?: boolean;
};

export function useLacChatbotAnalyticsQuery(
  tenantName: string | undefined,
  range?: LacTenantOverviewDateRange,
  options: UseLacChatbotAnalyticsQueryOptions = {},
) {
  const groupByKnowledgeBase = options.groupByKnowledgeBase ?? false;

  return useQuery({
    queryKey: lacQueryKeys.chatbotAnalytics(
      tenantName ?? '',
      range ?? null,
      groupByKnowledgeBase,
    ),
    enabled: Boolean(tenantName),
    queryFn: () => {
      if (!tenantName) {
        throw new Error('Missing tenant name');
      }
      return lacAnalyticsService.listChatbotAnalytics({
        tenantName,
        range,
        groupByKnowledgeBase,
      });
    },
  });
}
